import { AdaptiveCard } from 'adaptivecards-react';
import PropTypes from 'prop-types';
import React from 'react';

// React component that wraps an AdaptiveCards card component. Handles card events.
const Card = ({ body, handleCardActionSubmit }) => (
  <AdaptiveCard
    payload={body}
    hostConfig={{ fontFamily: 'Open Sans' }}
    onActionSubmit={handleCardActionSubmit}
  />
);

Card.propTypes = {
  body: PropTypes.object.isRequired,
  handleCardActionSubmit: PropTypes.func.isRequired
};

export default React.memo(Card);
